// @mui
import { Box, Breadcrumbs, Stack } from '@mui/material';
//
import { useMemo } from 'react';
import { PATH_DASHBOARD } from 'src/Router/paths';
import Iconify from 'src/components/iconify';
import { useBreakpoints } from 'src/hooks/useBreakpoints';
import { HeaderIcon } from 'src/layouts/DashboardLayout/shared/styles';
import LinkItem from './LinkItem';
import { BreadcrumbsLinkProps, CustomBreadcrumbsProps } from './types';

export default function DocsBreadcrumbs({
  doc,
  action,
  sx,
  ...other
}: CustomBreadcrumbsProps) {
  const { isSmallMobile } = useBreakpoints();

  const links = useMemo(() => {
    if (!Array.isArray(doc.parent) || isSmallMobile) {
      return [{ name: doc.title }];
    }
    const parents = doc.parent
      .reverse()
      ?.map<BreadcrumbsLinkProps>((content) => ({
        name: content.title,
        href: PATH_DASHBOARD.docs.view(content._id),
      }));

    return parents.concat({ name: doc.title });
  }, [doc.parent, doc.title, isSmallMobile]);

  return (
    <Box sx={{ ...sx }}>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        alignItems={{ xs: 'normal', lg: 'center' }}
      >
        <Box alignItems="center" sx={{ flexGrow: 1, display: 'flex', gap: 1 }}>
          <HeaderIcon>
            <Iconify icon="tabler:file-description" color="primary.main" />
          </HeaderIcon>
          {!!links?.length && (
            <Breadcrumbs
              separator={<Separator />}
              {...other}
              sx={{ typography: 'h6' }}
            >
              {links.map((link) => (
                <LinkItem key={link.name || ''} link={link} />
              ))}
            </Breadcrumbs>
          )}
        </Box>

        {action && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'end',
            }}
          >
            {' '}
            {action}{' '}
          </Box>
        )}
      </Stack>
    </Box>
  );
}

function Separator() {
  return (
    <Box component="span" sx={{ fontSize: '20px' }}>
      /
    </Box>
  );
}
